import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from "@core/services/authentication.service";

export const loggedOutGuard: CanActivateFn = () => {
  const auth = inject(AuthenticationService);
  const router = inject(Router);

  return !auth.isLoggedIn() ? true : router.createUrlTree(['/']);
};
